import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxComponent {

  @Input({ required: true }) controlId!: string;
  @Input({ required: true }) accessibleLabel!: string;
  @Input() checked = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<boolean>();

  toggleValue(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).checked);
  }
}
